"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeEnum = void 0;
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
var TypeEnum;
(function (TypeEnum) {
    TypeEnum["section"] = "section";
    TypeEnum["cardMain"] = "card-main";
    TypeEnum["card"] = "card";
    TypeEnum["sub"] = "sub";
    TypeEnum["main"] = "main";
    TypeEnum["small"] = "small";
})(TypeEnum = exports.TypeEnum || (exports.TypeEnum = {}));
const titleTypes = {
    [TypeEnum.section]: 'text-lg sm:text-xl font-header',
    [TypeEnum.cardMain]: 'text-xl sm:text-2xl font-header',
    [TypeEnum.card]: 'text-lg sm:text-xl font-header',
    [TypeEnum.sub]: 'text-base font-medium',
    [TypeEnum.main]: 'text-2xl sm:text-3xl font-header ',
    [TypeEnum.small]: 'text-xs font-header ',
};
function Title(props) {
    const TagName = props.as || 'h1';
    const baseClass = 'text-primary-500';
    const typeClass = (props.type && titleTypes[props.type]) || titleTypes[TypeEnum.main];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TagName, { className: (0, elements_ui_utils_1.classNames)(baseClass, typeClass, props.className || '') }, props.children),
        props.lead && react_1.default.createElement("p", { className: "text-lg text-primary-500" }, props.lead)));
}
exports.default = Title;
//# sourceMappingURL=title.js.map